export const hotels = [
    {
        id: 1,
        name: 'Pantelleria Dream',
        pack:'Dreaming pack',
        soldOut: false,
        link:'https://www.pantelleriaisland.it/',
        image:'pantelleria-dream.jpg',
    },
    {
        id: 2,
        name: 'Mursia Resort & Spa',
        pack:'Good Time Pack',
        soldOut: false,
        link:'https://www.pantelleriaisland.it/',
        image:'mursia.jpg',
    }
]
